import { InternalMessageBusChannels, internalMessageBus } from "sb-internal-msg-bus";
import { getRenewInterval, tokenParser } from "../helpers";
export class RequestGateway {
    constructor(requestService) {
        this.maxRetries = 5;
        this.messageBus = internalMessageBus;
        this.requestService = requestService;
        this.reloadTimeout = -1;
        this.retryCount = 0;
        this.recursiveRenew = this.recursiveRenew.bind(this);
    }
    sendTokenRenewMessage() {
        this.messageBus.emit(InternalMessageBusChannels.legacy.anonymousJWTChange.renewJWTToken, { token: this.getExistingToken() });
        this.messageBus.emit(InternalMessageBusChannels.authorization.renewJWTToken, { token: this.getExistingToken() });
    }
    setRenewToken(requestMethod) {
        if (this.getExistingToken()) {
            window.clearTimeout(this.reloadTimeout);
            let parsedToken = tokenParser(this.getExistingToken());
            let renewInterval = getRenewInterval(parsedToken.exp);
            this.reloadTimeout = window.setTimeout(() => {
                requestMethod()
                    .catch((err) => new Error(err));
            }, renewInterval);
        }
    }
    onSuccessResponse(token, requestMethod) {
        this.setToken(token);
        this.sendTokenRenewMessage();
        this.setRenewToken(requestMethod);
        return this.getExistingToken();
    }
    recursiveRenew(err, requestMethod, resolve, reject) {
        this.retryCount++;
        if (this.retryCount <= this.maxRetries) {
            setTimeout(() => {
                requestMethod()
                    .then(token => {
                    resolve(token);
                })
                    .catch(x => this.recursiveRenew(x, requestMethod, resolve, reject));
            }, 1000);
        }
        else {
            reject(err);
        }
    }
    getAnonymousToken() {
        return this.requestService
            .getAnonymousToken()
            .then(response => this.onSuccessResponse(response, this.getAnonymousToken.bind(this)))
            .catch(err => { throw err; });
    }
    // private successResponseAnonymous(token: string) {
    //     this.setToken(token);
    //     this.sendTokenRenewMessage(InternalMessageBusChannels.legacy.anonymousJWTChange.renewJWTToken);
    //     this.setRenewToken(this.getAnonymousToken);
    //     return this.getExistingToken();
    // }
    getLoginToken(params) {
        return this.requestService
            .getLoginToken(params)
            .then(response => this.onSuccessResponse(response, this.getLoginToken.bind(this, params)))
            .catch(err => { throw err; });
    }
}
//# sourceMappingURL=RequestGateway.js.map